import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import es from 'date-fns/locale/es';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import parseISO from 'date-fns/parseISO';


export const InputDatePicker = ({ ...props }: any) => (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
        <DatePicker
            format='dd/MM/yyyy'
            {...props}
            value={props.value ? (typeof props.value === 'string' ? parseISO(props.value) : props.value) : null}
            className="form-control"
            slotProps={{
                field: {
                    clearable: true,
                },
                textField: {
                    size: 'small',
                    error: props.error,
                    className: `${props.error ? 'is-invalid' : ''}`,
                },
            }}
        />
    </LocalizationProvider>
)